import { Pressable, Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { colors, fonts, minSafeArea } from '../theme';

/** Shared header for both the Stack ((app)/_layout.tsx) and Tabs
 * ((app)/(tabs)/_layout.tsx) navigators. Both React Navigation's native
 * header implementations render fine on real native iOS/Android, but on the
 * web/PWA export they don't reliably reserve the safe-area top inset (the
 * title can render underneath the status bar / notch) — so we replace the
 * default header entirely with one that pads itself using the real inset,
 * with a sane minimum fallback for browsers that report 0. */
export function AppHeader({
  title,
  canGoBack,
  onBack,
}: {
  title: string;
  canGoBack?: boolean;
  onBack?: () => void;
}) {
  const insets = useSafeAreaInsets();
  const statusBarHeight = Math.max(insets.top, minSafeArea.top);

  return (
    <View
      style={{
        paddingTop: statusBarHeight,
        backgroundColor: colors.card,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
      }}
    >
      <View
        style={{
          height: 48,
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 8,
        }}
      >
        {canGoBack ? (
          <Pressable onPress={onBack} hitSlop={10} style={{ padding: 8 }}>
            <Ionicons name="chevron-back" size={24} color={colors.text} />
          </Pressable>
        ) : (
          <View style={{ width: 40 }} />
        )}
        <Text
          style={{ flex: 1, fontFamily: fonts.bold, fontSize: 17, color: colors.text }}
          numberOfLines={1}
        >
          {title}
        </Text>
        <View style={{ width: 40 }} />
      </View>
    </View>
  );
}
